{
    "PageTitle_auth": "Authentifizierung",
    "NAME": "Router",
    "PageTitle_presence": "Anwesenheit",
    "PageTitle_changePassword": "Kennwort ändern",
    "PageTitle_forgotPassword": "Passwort vergessen",
    "PageTitle_changeLanguage": "Sprache ändern",
    "PageTitle_resetPassword": "Passwort zurücksetzen",
    "PageTitle_termsAndConditions": "Geschäftsbedingungen",
    "PageTitle_cookiePolicy": "Cookie-Richtlinie",
    "PageTitle_privacyPolicy": "Datenschutzrichtlinie",
    "PageTitle_mfa": "Multi-Faktor-Authentifizierung",
    "PageTitle_teamsAuth": "Teams-Authentifizierung",
    "PageTitle_insights": "Einblicke",
    "PageTitle_crmIntegration": "CRM-Integration",
    "PageTitle_changeUserAgent": "Benutzeragent ändern",
    "PageTitle_clientConfiguration": "Client-Konfiguration",
    "PageTitle_CRMConfiguration": "CRM-Konfiguration",
    "PageTitle_adminControl": "Administratorsteuerung",
    "PageTitle_admin": "Verwaltung",
    "PageTitle_cme": "CMEs",
    "PageTitle_status": "Anwendungsserverstatus",
    "PageTitle_licences": "Lizenzen",
    "PageTitle_licenceManagement": "Lizenzmanagement",
    "PageTitle_telsys": "Telefonieserver",
    "PageTitle_users": "Anwendungsbenutzer",
    "PageTitle_partitions": "Partitionen",
    "PageTitle_device": "Geräte",
    "PageTitle_agent": "Agenten",
    "PageTitle_code": "Codes",
    "PageTitle_auditTrail": "Prüfprotokoll",
    "PageTitle_logManagement": "Protokollverwaltung",
    "PageTitle_loggingSettings": "Protokollierungseinstellungen",
    "PageTitle_telModuleStatus": "Status des Telefonmoduls",
    "PageTitle_recording": "Aufnahme",
    "PageTitle_messages": "Nachrichten",
    "PageTitle_database": "Datenbank",
    "PageTitle_directory": "Verzeichnis",
    "PageTitle_cxScore": "CX-Score",
    "PageTitle_cxScore-cx-score": "CX-Score",
    "PageTitle_cxScore-overview": "CX-Score",
    "PageTitle_cxScore-calls": "CX-Score",
    "PageTitle_cxiDashboard": "CXI-Dashboard"
}